import React from 'react';
import AboutMe from './AboutMe';
import Habilidades from './Habilidades';

const About: React.FC = (): JSX.Element => {
  return (
      <>
      <AboutMe/>
      <Habilidades/>
      </>
  );
};

export default About;